import { useEffect, useRef, useState } from "react";
import ReactCrop from 'react-image-crop'
import * as Constants from "../../config";
import axios from "axios";
import { useTranslation } from "react-i18next";

export default function AddSlide(props){
    const [imgSrc, setImgSrc] = useState('');

    const [dataInProgressState,setDataInProgressState] = useState(false);
    const [imageCropped, setImageCropped] = useState();
    const imgRef = useRef(null);
    const inputFile = useRef(null);    
    const [title, setTitle] = useState(props.record.title);
    const [text, setText] = useState(props.record.text);
    const [image, setImage] = useState(props.record.image);
    const [link, setlink] = useState(props.record.link);
    const { t } = useTranslation();
    const canvasRef = useRef(null);
    const [aspect, setAspect] = useState(9 / 14)
    const [crop, setCrop] = useState();
    const [zoom, setZoom] = useState(1);
    const onCropComplete = (croppedArea, croppedAreaPixels) => {
        console.log(croppedArea, croppedAreaPixels)
    }

    function changeTitle(e){
        setTitle(e.target.value);
    }

    function changeText(e){
        setText(e.target.value);
    }
    function changeLink(e){
        setlink(e.target.value);
    }
    function saveRecord(){
        props.saveRecord({id:props.record.id, title:title, text:text, image:image, link:link});
        props.closeWindow();
    }

    function getImages() {
        fetch(Constants.apiurl + Constants.imagesListPath + "?id=" + props.record.id)
        .then((response) => response.json())
        .then((data) => {
            setImage(data);
            console.log(data);
        })
        .catch((err) => {
            console.log(err.message);
        });
    }

    const cropImage = async () => {
        const croppedFile = await cropImageNow();
        if (croppedFile) {
            uploadImages([croppedFile]); 
        }
    };

    const handleFileUpload = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            setCrop(undefined) // Makes crop preview update between images.
            const reader = new FileReader()
            reader.addEventListener('load', () =>
                setImgSrc(reader.result?.toString() || ''),
            )
            reader.readAsDataURL(e.target.files[0])
        }
        //uploadImages(files);
      };

      function uploadImages(files){
        var update = false;
        if(files.length < 1) return;        
        for(var i in files){
            var file = files[i];
            if(!(file.name) || file.name=="")return;
            update=true;
            const formData = new FormData();         
            setDataInProgressState(true);
            formData.append("file", file);
            axios
                .post(Constants.apiurl + Constants.imageUpload + "?id=" + props.record.id, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Authorization": localStorage.getItem("token")
                },
                })
                .then(response => {
                    if(response.status == 401) window.location.reload(false);
                    getImages();
                    return response.json();
                })
                .catch((error) => { 
                    setDataInProgressState(false);
                })
                .finally(()=>{
                    imgRef.current = null;
                    setImgSrc(null);
                });
        }         
        if(update)getImages();    
        setDataInProgressState(false);
      }
    
    const deleteImage = (x) => {
        setDataInProgressState(true);
        fetch(Constants.apiurl + Constants.deleteimagePath + "?name=" + x.name)
        .then((data) => {
            getImages();
            setDataInProgressState(false);
        })
        .catch((err) => {            
            setDataInProgressState(false);
            console.log(err.message);
        });
    };
    const cropImageNow = async () => {
        if (!imgRef.current || !crop.width || !crop.height) return null;

        const image = imgRef.current;
        const canvas = document.createElement("canvas");
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;

        canvas.width = crop.width * scaleX;
        canvas.height = crop.height * scaleY;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width * scaleX,
            crop.height * scaleY
        );

        // определяем качество: если исходный файл >5МБ, ставим 0.6, иначе 1
        let quality = 1;
        if (inputFile.current?.files && inputFile.current.files[0]?.size > 5 * 1024 * 1024) {
            quality = 0.6;
        }

        return new Promise((resolve) => {
            // конвертируем в JPEG, чтобы качество можно было регулировать
            canvas.toBlob(
                (blob) => {
                    if (!blob) return resolve(null);
                    const file = new File([blob], "cropped_image.jpg", { type: "image/jpeg" });
                    resolve(file);
                },
                "image/jpeg",
                quality
            );
        });
    };
    return(
        <>        
            <canvas ref={canvasRef} style={{ display: "none" }} />
            <link href="https://unpkg.com/react-image-crop/dist/ReactCrop.css" rel="stylesheet" />
            <script src="https://unpkg.com/react-image-crop/dist/index.umd.cjs"></script>
            <div className="modal-window">
                <div id="add-review">
                    <div id='field'>
                        <label>Title:</label>
                        <input value={title} onChange={changeTitle}/>
                    </div>
                    <div id='field'>
                        <label>Text:</label>
                        <textarea value={text} onChange={changeText}/>
                    </div>
                    <div id='field'>
                        <label>{t('Offer Id:')}</label>
                        <input value={link} onChange={changeLink}/>
                    </div>
                    <div id='field'>
                        <label>Image:</label>
                        <input onChange={handleFileUpload} accept="image/png, image/gif, image/jpeg" ref={inputFile} type="file" id="pictures"  name="files"/>
                    </div>
                    {!!(imgSrc) ?
                        <>
                        <ReactCrop crop={crop} onChange={c => setCrop(c)} aspect={aspect}>
                            <img ref={imgRef} src={imgSrc} />
                        </ReactCrop>                   
                        <button onClick={cropImage}>Crop and save</button>
                        </>
                        :""
                    }
                    <div id="apart-images">
                    {!!(image) ? image.map(x=>
                            <div>
                                <div onClick={()=>deleteImage(x)} className="close-icon">X</div>
                                <img src={x.link}/>
                            </div>
                        ) : ""}
                    </div>
                    <div className="buttons-block">
                        <div onClick={saveRecord} className="add-button">Save</div>
                        <div onClick={props.closeWindow} className="delete-button">{t('Fermer')}</div>
                    </div>
                </div>
            </div>
        </>
    )
}